import React, { useState, ChangeEvent, FormEvent } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import api from "api";
import { updateFacilityMonitoring, createFacilityMonitoring } from "helpers/facilityMonitoring";

import { Col } from "ui/blocks/WaterQuality/WaterQualityView/Col";
import { Button } from "ui/base/Button";
import { FormRow, Label, Text, SubmitBtn, IconWrapper } from "ui/blocks/ContactUsView/ContactUsViewStyled";
import { useToaster } from "context/TosterContext";
import { UploadFile } from "ui/icons/UploadFile";

interface RootState {
  user: {
    id: number;
  } | null;
}

const MonthlyObservationFormUpdate: React.FC = () => {
  const { addToast } = useToaster();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);

  const idParam = queryParams.get("id");
  const wdid = queryParams.get("wdid");
  const year = queryParams.get("year");
  const month = queryParams.get("month");

  const id = idParam ? Number(idParam) : null;

  const user = useSelector((state: RootState) => state.user);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [fileName, setFileName] = useState<string>("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!selectedFile) return;

    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("input", selectedFile);

      const response = await api.addOne(formData);
      const fileUrl = response?.data?.url;

      if (fileUrl) {
        if (id !== null) {
          await updateFacilityMonitoring(id, "facility_monitoring", { url: fileUrl });
        } else {
          if (!user) {
            throw new Error("No user found");
          }
          await createFacilityMonitoring("facility_monitoring", {
            user_id: user.id,
            url: fileUrl,
            wdid: wdid,
            facility: wdid,
            year: year,
            month: month,
            status: `Completed ${new Date().toLocaleDateString()}`,
          });
        }
        addToast("Successfully uploaded!", "success");
        setTimeout(() => {
          navigate("/monitoring");
        }, 2000);
      } else {
        throw new Error("Can't get file url");
      }
    } catch (error) {
      console.error("Error: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
    } else {
      setSelectedFile(null);
      setFileName("");
    }
  };

  return (
    <div style={{ margin: "40px" }}>
      <div className="header" style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button color="white" background="darkBlue" onClick={() => navigate("/monitoring")}>
          Back
        </Button>
      </div>
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          border: "5px dashed #183765",
          maxWidth: "800px",
          padding: "60px 20px",
          margin: "40px auto",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <Col>
          <div style={{ width: "100px", marginLeft: "15px", opacity: "0.5" }}>
            <UploadFile />
          </div>
        </Col>
        <FormRow
          style={{
            width: "100%",
            display: "flex",
            marginTop: "-5px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Label htmlFor="file-input" style={{ cursor: "pointer", width: "fit-content" }}>
            <span style={{ marginLeft: "5px", whiteSpace: "nowrap" }}>Drop Files Here to Upload</span>
            <input
              onChange={handleFileChange}
              name="link"
              type="file"
              id="file-input"
              style={{ display: "none" }}
              accept=".jpg,.jpeg,.png,.pdf"
            />
          </Label>
          {fileName && <Text>{fileName}</Text>}
        </FormRow>
        {selectedFile && (
          <FormRow>
            <SubmitBtn type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : id !== null ? "Upload" : "Create"}
            </SubmitBtn>
          </FormRow>
        )}
      </form>
    </div>
  );
};

export default MonthlyObservationFormUpdate;
